export const getIsSnackbarVisible = state => state.snackbar.get('isVisible')
export const getIsSnackbarSticky = state => state.snackbar.get('isSticky')
export const getSnackbarMessage = state => state.snackbar.get('message')
